'use strict';/* global define, console */define('modules/time/services/time-manipulation/index',['require','exports','module'],function(require,exports,module){'use strict';// @ngInject
function factory(){// jshint validthis:true
// jshint latedef:false
//TODO Create unit tests
return{incrementHour:incrementHour,decreaseHour:decreaseHour,incrementMinutes:incrementMinutes,decreaseMinutes:decreaseMinutes};/**
     * Increment the selected hour
     *
     * @param  {String} hour   - Hour representation e.g. 02, 14
     *
     * @return {String|Number} - Formatted hour as a result
     *
     * @tested
     */function incrementHour(hour){var hourInteger=parseInt(hour,10);if(hourInteger<23){hour=hourInteger+1;}else{hour=0;}hour='00'.substr(String(hour).length)+hour;return hour;}/**
     * Decrease the selected hour
     *
     * @param  {String} hour   - Hour representation e.g. 02, 14
     *
     * @return {String|Number} - Formatted hour as a result
     *
     * @tested
     */function decreaseHour(hour){var hourInteger=parseInt(hour,10);if(hourInteger===0){hour=23;}else{hour=hourInteger-1;}hour='00'.substr(String(hour).length)+hour;return hour;}/**
     * Increment the selected minutes and hour if needed
     *
     * @param  {String} hour    - Hour representation e.g. 02, 14
     * @param  {String} minutes - Minutes representation e.g. 02, 59
     * @param  {String} step    - Step in minutes
     *
     * @return {Object}         - Object which contains the udpated hour
     *                            and minutes
     * @tested
     */function incrementMinutes(hour,minutes,step){var minutesInteger=parseInt(minutes,10);minutes=minutesInteger+parseInt(step,10);if(minutes>59){minutes='00';hour=incrementHour(hour);}else{minutes='00'.substr(String(minutes).length)+minutes;}return{hour:hour,minutes:minutes};}/**
     * Decrease the selected minutes and hour if needed
     *
     * @param  {String} hour    - Hour representation e.g. 02, 14
     * @param  {String} minutes - Minutes representation e.g. 02, 59
     * @param  {String} step    - Step in minutes
     *
     * @return {Object}         - Object which contains the udpated hour
     *                            and minutes
     * @tested
     */function decreaseMinutes(hour,minutes,step){var minutesInteger=parseInt(minutes,10);var stepInteger=parseInt(step,10);minutes=minutesInteger-stepInteger;if(minutes<0){minutes=60-stepInteger;hour=decreaseHour(hour);}minutes='00'.substr(String(minutes).length)+minutes;return{hour:hour,minutes:minutes};}}module.exports=factory;});
